export default "__VITE_ASSET__DZy40OYl__"